<div class="profile-container">
  <div class="profile-content">
    <div class="personal-details">

      <!-- HEADER -->
      <div class="header-block">
        <div class="header-title">
          <app-breadcrumb></app-breadcrumb>
        </div>
        <div class="add-block">
          <div hidden="true">
            <input type="file" #excelFileInput (change)="onExcelFileChange($event, excelFileInput)" id="add-btn"
              accept=".xlsx, .xls" />
          </div>
          <button class="outline-btn" title="Download File" (click)="downloadSample()"><i class="bi bi-download"></i>
            Download File</button>
          <button title="select excel" (click)="addAssetClick()"><i class="bi bi-upload"></i> Upload File</button>

          <div class="filter-icon">
            <i class="bi bi-arrow-clockwise" (click)="refresh()" title="Refresh"></i>
          </div>
        </div>
      </div>

      <!-- MAIN CONTENT -->
      <div class="map-content-wrapper">
        <!-- MAP -->
        <div class="map-panel" [class.map-fullscreen]="isFullscreen">
          <button class="fullscreen-btn" (click)="toggleFullscreen()"
            [title]="isFullscreen ? 'Exit Fullscreen' : 'Fullscreen'">
            <i class="bi" [ngClass]="isFullscreen ? 'bi-fullscreen-exit' : 'bi-fullscreen'"></i>
          </button>
          <div id="map"></div>
        </div>

        <!-- LIST SIDEBAR -->
        <div class="list-panel">
          <!-- List Heading -->
          <div class="list-heading">
            <h3>Asset List</h3>
            <div class="heading-actions">
              <span class="asset-count">{{listingResponse.length}}</span>
              <button class="submit-btn" (click)="submit()" [disabled]="isLoading">
                <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-1" role="status"
                  aria-hidden="true"></span>
                {{ isLoading ? 'Submitting...' : 'Submit' }}
              </button>
            </div>
          </div>

          <!-- Locations -->
          <div class="location-list">
            <div class="empty-state" *ngIf="listingResponse.length === 0">
              <p>No Assets found</p>
            </div>

            <div class="location-card" *ngFor="let item of listingResponse; let i = index"
              [class.active]="item.selected" (click)="toggleSelection(i)">
              <!-- <div class="check-circle" [class.checked]="item.selected">
                <i class="bi bi-check2" *ngIf="item.selected"></i>
              </div> -->
              <div class="location-info">
                <div class="location-name">
                  {{item.name}}
                </div>
              </div>
              <div class="asset-icons-container" *ngIf="(!item.multilatlng && (!item.lat || !item.lng)) || (item.multilatlng && (!item.latlng || item.latlng.length === 0))">
                <div class="text-primary type-icon" [title]="item.multilatlng ? 'Line location' : 'Point location'">
                  <i class="bi" [ngClass]="item.multilatlng ? 'bi-bezier2' : 'bi-geo-alt-fill'"></i>
                </div>
                <div class="text-warning warning-icon" title="Location missing">
                  <i class="bi bi-exclamation-circle"></i>
                </div>
              </div>
              <div class="action-icon ms-2" *ngIf="item.selected">
                <i class="bi bi-chevron-right"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>